import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { reactivateUser } from "../redux/usersSagas";

export const Reactivate = ({ isOpen, onClose, selected: { id, name } = {} }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(reactivateUser({ id }));
    onClose();
  };

  return (
    <MainModal
      parentSelector=".admin-users"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Delete"
      headerCloseHandler={onClose}
      width={300}
      height="auto"
      primaryButtonText="Reactivate"
      primaryBtnHandler={primaryBtnHandler}
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      containerClassName="dialog"
    >
      Are you sure to reactivate <span className="text-bold">{name}</span> user?
    </MainModal>
  );
};
